import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Signup from './scenes/Signup';
import Login from './scenes/Login';
import AcceptInvite from './scenes/AcceptInvite';
import AccountActivate from './scenes/AccountActivate';
import AccountResetPassword from './scenes/AccountResetPassword';
import AccountForgotPassword from './scenes/AccountForgotPassword';
import GoogleCallback from './scenes/Auth/GoogleCallback';
import { AuthProvider } from '@dashboard/context/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PublicLayout from './layouts/PublicLayout';
import AccountVerifyEmailChange from '@/dashboard/scenes/AccountVerifyEmailChange';
import { ToastProvider } from '@/dashboard/context/ToastContext';

// Create a client
const queryClient = new QueryClient();

const PublicRoute = ({ component: Component, ...rest }) => (
  <PublicLayout {...rest}>
    <Route {...rest} render={matchProps => <Component {...matchProps} />} />
  </PublicLayout>
);

export default function unauthorizedRoutes() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider value={{ shouldAuthenticate: false }}>
        <ToastProvider>
          <Switch>
            <PublicRoute path="/signup" component={Signup} />
            <PublicRoute path="/login" component={Login} />
            <PublicRoute path="/accept-invite" component={AcceptInvite} />
            <PublicRoute path="/auth/google/callback" component={GoogleCallback} />

            <PublicRoute path="/account/activate/:activationToken" component={AccountActivate} />

            <PublicRoute
              path="/account/verify-email-change/:emailChangeToken"
              component={AccountVerifyEmailChange}
            />

            <PublicRoute path="/account/forgot-password" component={AccountForgotPassword} />

            <PublicRoute
              path="/account/reset-password/:resetPasswordToken"
              component={AccountResetPassword}
            />
          </Switch>
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
